import { Outlet, useLocation } from '@tanstack/react-router';

import { useBreadcrumbs } from '@/app/hooks/useBreadcrumbs';
import { useHeaderActions } from '@/app/hooks/useHeaderActions';
import { usePageTitle } from '@/app/hooks/useTitle';

import { Navbar } from '@/components/layout/Navbar';
import { Page } from '@/components/layout/Page';
import { PageHeader } from '@/components/layout/PageHeader';
import { AppSidebar } from '@/components/sidebar';

import { SidebarInset, SidebarProvider, SidebarTrigger } from 'ui/sidebar';

export const Layout = () => {
  const { breadcrumbs } = useBreadcrumbs();
  const { title } = usePageTitle();
  const { actions } = useHeaderActions();
  const { pathname } = useLocation();
  const isSystemPage = pathname === '/forbidden';

  return (
    <SidebarProvider
      style={
        {
          '--sidebar-width': isSystemPage ? 'var(--sidebar-width-icon)' : '264px',
        } as React.CSSProperties
      }
    >
      <AppSidebar />

      <SidebarInset className="max-w-full overflow-hidden">
        {!isSystemPage && <SidebarTrigger className="absolute -left-3 top-17.5 z-40" />}
        <header className="sticky top-0 flex shrink-0 items-center gap-2 bg-background">
          <Navbar />
        </header>
        <Page>
          {!isSystemPage && <PageHeader breadcrumbs={breadcrumbs} title={title} actions={actions} />}
          <Outlet />
        </Page>
      </SidebarInset>
    </SidebarProvider>
  );
};
